// Custom responsive closure IEF module for moving description around on multipack pages
(function adjustWidthModule() {
        var desc = document.querySelector('.section.product_section .description').firstElementChild;
        var price = document.querySelector('.section.product_section .modal_price');
        var form = document.querySelector('.section.product_section .product_form');

        function moveDesc() {
                var width = window.innerWidth;
                if(width >= 980) {
                        price.after(desc);
                } else {
                        form.after(desc);
                } 
        }
        
        moveDesc();
        window.addEventListener('resize', moveDesc);    

})();
